import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "details"]

  toggle(event) {
    this.checkboxTarget.checked = this.detailsTarget.value.trim() !== ""
  }
}
